'use strict';

import "@babel/polyfill";
import 'slick-carousel';
import 'modaal';
// import 'modal-video';

import { ua } from './view/_ua';
import { utility } from './view/_utility';
import { header } from './view/_header';
import { height } from './view/_height';
import { scroll } from './view/_scroll';
import { smoothScroll } from './view/_smoothScroll'
import { count } from './view/_count'


